import React from 'react';
import { useMutation } from '@apollo/client';
import TASK_TOGGLE_PHOTO_REQUIRED from '../gql/taskTogglePhotoRequired.graphql';
import { FormattedMessage } from 'react-intl';

import toast from 'helpers/toast';
import { getGqlErrors } from 'components/projects/taskList/helpers';

const useTaskTogglePhotoRequired = ({ taskId, onError = () => {} }) => {
  const showErrorToast = (errorMsg) => {
    toast.error(
      errorMsg || (
        <FormattedMessage
          id="Projects.taskList.templates.error.toggleRequirePhoto"
          defaultMessage="There was an error toggling the photo requirement"
          description="Default error message for toggling photo requirement"
        />
      ),
    );
  };

  const [togglePhotoRequired, { loading }] = useMutation(
    TASK_TOGGLE_PHOTO_REQUIRED,
    {
      variables: {
        input: { id: taskId },
      },
      onCompleted: (data) => {
        const gqlErrors = getGqlErrors(data);

        if (gqlErrors.length) {
          showErrorToast(gqlErrors[0].message);
          onError();
        }
      },
      onError: () => {
        showErrorToast();
        onError();
      },
    },
  );

  return {
    togglePhotoRequired,
    loading,
  };
};

export default useTaskTogglePhotoRequired;
